/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Box, Card, CardContent, Container, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import "./OverallStatus.css";
import Constants from "../constants";

/**
 * OverallStatus component
 * Description: This component displays the overall status of the application
 */
function OverallStatus({ status, message }) {
  const { description, backgroundColor, color, IconComponent } = Constants.status[status];

  // const favicons = {
  //   0: "favicon-operational.svg",
  //   1: "favicon-maintenance.svg",
  //   2: "favicon-degraded.svg",
  //   3: "favicon-partial-outage.svg",
  //   4: "favicon-major-outage.svg"
  // };

  // useEffect(() => {
  //   const favicon = document.getElementById("favicon");

  //   if (favicon && favicons[status]) {
  //     favicon.href = `/favicons/${favicons[status]}`;
  //   } else {
  //     favicon.href = "/favicon.svg";
  //   }
  // }, [ status ]);

  return (
    <Container sx={ { my: 4 } }>
      <Card variant="elevation" elevation={ 4 } sx={ { backgroundColor: backgroundColor, color: color } }>
        <CardContent className="overall-status">
          <Typography component="div" sx={ { fontWeight: "bold" } }>
            <Box component="span" sx={ { alignItems: "center", display: "flex" } }>
              <IconComponent />
              <Box component="span" sx={ { pl: 1 } }>
                { message ? message : description }
              </Box>
            </Box>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}

OverallStatus.propTypes = {
  message: PropTypes.string,
  status: PropTypes.number
};

export default OverallStatus;
